import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
import store from '../store';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

const SIPDevices = () =>
    import('src/pages/SIPDevices/SIPDevices.vue');
const Billing = () =>
    import('src/pages/Billing/Billing.vue');
const UserProfile = () =>
    import('src/pages/Profile/UserProfile.vue');
const Voicemail = () =>
    import('src/pages/Voicemail/Voicemail.vue');
const CDR = () =>
    import('src/pages/CDR/CDR.vue');
const Ringgroups = () =>
    import('src/pages/Ringgroup/Ringroups.vue');
const Timeconditions = () =>
    import('src/pages/Timeconditions/Timeconditions.vue');
const IVRs = () =>
    import('src/pages/IVR/IVRs.vue');
const InternalExtensions = () =>
    import('src/pages/InternalExtension/InternalExtension.vue');
const Queues = () =>
    import('src/pages/Queue/Queues.vue');
const PhoneNumbers = () =>
    import('src/pages/PhoneNumbers/PhoneNumbers.vue');
const Contacts = () =>
    import('src/pages/Contacts/Contacts.vue');
const CallFlow = () =>
    import('src/pages/CallFlow/CallFlow.vue');
const Voicemailbox = () =>
    import('src/pages/Voicemailbox/Voicemailbox.vue');
const MusicOnHold = () =>
    import('src/pages/MusicOnHold/MusicOnHold.vue');
const SystemRecording = () =>
    import('src/pages/SystemRecording/SystemRecording');
const BulletinSetup = () =>
    import('src/pages/Bulletin/Setup/Bulletin');
const BulletinAdminSetup = () =>
    import('src/pages/Bulletin/Setup/AdminBulletin');
const Bulletin = () =>
    import('src/pages/Bulletin/Normal/Bulletins');

const School = () =>
    import('src/pages/School/school');
const Classroom = () =>
    import('src/pages/School/classroom');
const StudentCallHistory = () =>
    import('src/pages/School/Student/CallHistory');

// Dashboard pages
const Dashboard = () =>
    import('src/pages/Dashboard/Dashboard.vue');

// Pages
const Pricing = () =>
    import('src/pages/Pages/Pricing.vue');
const Login = () =>
    import('src/pages/Pages/Login.vue');
const Forgot = () =>
    import('src/pages/Pages/Forgot.vue');
const Register = () =>
    import('src/pages/Pages/Register.vue');
const Reset = () =>
    import('src/pages/Pages/Reset.vue');
const RTL = () =>
    import('src/pages/Pages/RTLPage.vue');
const Lock = () =>
    import('src/pages/Pages/Lock.vue');


let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: (to, from, next) => {
                if (store.getters.isAuthenticated) {
                    next('/dashboard')
                }
                next()
            }
        }, {
            path: '/forgot',
            name: 'Forgot',
            component: Forgot,
        }, {
            path: '/reset/:token',
            name: 'Reset',
            component: Reset,
        }, {
            path: '/logout',
            name: 'Logout',
            component: Login,
            beforeEnter(to, from, next) {
                store.commit('customer/resetState');
                store.commit('billing/resetState');
                store.commit('ringgroup/resetState');
                store.commit('callroute/resetState');
                store.commit('did/resetState');
                store.commit('ivr/resetState');
                store.commit('queue/resetState');
                store.commit('sipdevice/resetState');
                store.commit('voicemail/resetState');
                localStorage.clear();
            },
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/pricing',
            name: 'Pricing',
            component: Pricing
        },
        {
            path: '/lock',
            name: 'Lock',
            component: Lock
        }
    ]
};

let adminLoginPages = {
    path: '/admin/login',
    name: 'AdminLogin',
    beforeEnter(to, from, next) {
        let token = to.query.accesstoken;
        if (token) {
            store.dispatch('AUTH_ADMIN_LOGIN', token).then(() => {
                next('/dashboard');
            }).catch(() => {
                next('/login');
            });
        } else {
            next('/login');
        }
    },
};


let teacherLoginPages = {
    path: '/teacher/login',
    name: 'TeacherLogin',
    beforeEnter(to, from, next) {
        let token = to.query.accesstoken;
        console.log(token);
        if (token) {
            store.dispatch('AUTH_TEACHER_LOGIN', token).then(() => {
                console.log(localStorage.getItem('teacher'));
                next('/school/classroom/' + localStorage.getItem('teacher'));
            }).catch(() => {
                next('/login');
            });
        } else {
            next('/login');
        }
    },
};

let userLoginPages = {
    path: '/user/billing/login',
    name: 'OldUserBillingLogin',
    beforeEnter(to, from, next) {
        let token = to.query.accesstoken;
        if (token) {
            console.log('Found token');
            store.dispatch('AUTH_OLD_USER_BILLING_LOGIN', token).then(() => {
                setTimeout(() => {
                    next('/billing');

                }, 1000);
            }).catch(() => {
                next('/billing');
            });
        } else {
            next('/billing');
        }

        next('/billing');
    },
};

const routes = [
        {path: '/', redirect: '/login'},
        authPages,
        {
            path: '/',
            component: DashboardLayout,
            name: 'Dashboard layout',
            meta: {
                requiredAuth: true,
            },
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    components: {default: Dashboard},
                },
                {
                    path: 'numbers',
                    name: 'Phone Numbers',
                    components: {default: PhoneNumbers},
                    meta: {
                        permission: 'view-number'
                    }
                }, {
                    path: 'callflow/:did',
                    name: 'Call Flow Number',
                    components: {default: CallFlow},
                    meta: {
                        permission: 'view-callflow'
                    }
                }, {
                    path: 'callflow/:ivr/:button',
                    name: 'Call Flow IVR',
                    components: {default: CallFlow},
                    meta: {
                        permission: 'view-callflow'
                    }
                }, {
                    path: 'musiconhold',
                    name: 'Music On Hold',
                    components: {default: MusicOnHold},
                    meta: {
                        permission: 'view-musiconhold'
                    }
                }, {
                    path: 'systemrecording',
                    name: 'System Recording',
                    components: {default: SystemRecording},
                    meta: {
                        permission: 'view-systemrecording'
                    }
                },
                {
                    path: 'devices',
                    name: 'Devices',
                    components: {default: SIPDevices},
                    meta: {
                        permission: 'view-device'
                    }
                }, {
                    path: 'contact',
                    name: 'Contacts',
                    components: {default: Contacts},
                },
                {
                    path: 'billing',
                    name: 'Billing',
                    components: {default: Billing},
                    meta: {
                        permission: 'view-invoice'
                    }
                },
                {
                    path: 'profile',
                    name: 'Profile',
                    components: {default: UserProfile},
                    meta: {
                        permission: 'view-profile'
                    }
                },
                {
                    path: 'voicemessages',
                    name: 'Voicemessages',
                    components: {default: Voicemail},
                    meta: {
                        permission: 'view-voicemessage'
                    }
                }, {
                    path: 'callrecords',
                    name: 'Call Records',
                    components: {default: CDR},
                    meta: {
                        permission: 'view-cdr'
                    }
                }, {
                    path: 'ringgroups',
                    name: 'Ringgroups',
                    components: {default: Ringgroups},
                    meta: {
                        permission: 'view-ringgroup'
                    }
                }, {
                    path: 'timeconditions',
                    name: 'Timeconditions',
                    components: {default: Timeconditions},
                    meta: {
                        permission: 'view-timecondition'
                    }
                }, {
                    path: 'ivrs',
                    name: 'IVR',
                    components: {default: IVRs},
                    meta: {
                        permission: 'view-ivr'
                    }
                }, {
                    path: 'internal',
                    name: 'Internal Extensions',
                    components: {default: InternalExtensions},
                    meta: {
                        permission: 'view-internal'
                    }
                }, {
                    path: 'queues',
                    name: 'Queue',
                    components: {default: Queues},
                    meta: {
                        permission: 'view-queue'
                    }
                }, {
                    path: 'voicemailbox',
                    name: 'Voicemailbox',
                    components: {default: Voicemailbox},
                    meta: {
                        permission: 'view-voicemailbox'
                    }
                },
                {
                    path: 'bulletins',
                    name: 'Bulletin',
                    components: {default: Bulletin},
                }, {
                    path: 'school',
                    name: 'School',
                    components: {default: School},
                },
                {
                    path: 'school/classroom/:classroom',
                    name: 'Classroom',
                    components: {default: Classroom},
                    meta: {
                        permission: 'teacher'
                    }
                },
                {
                    path: 'school/classroom/:classroom/student/:student/history',
                    name: 'StudentCallHistory',
                    components: {default: StudentCallHistory},
                    meta: {
                        permission: 'teacher'
                    }
                },
            ]
        },
        adminLoginPages,
        userLoginPages,
        teacherLoginPages,
        {
            path: '/bulletin/setup',
            name: 'bulletinSetup',
            components: {BulletinSetup, default: BulletinSetup},
        }, {
            path: '/bulletin/admin-setup',
            name: 'bulletinAdminSetup',
            components: {BulletinAdminSetup, default: BulletinAdminSetup},
        },
        {path: '*', component: NotFound}
    ]
;

export default routes;
